export const redefineOrder = <T extends Sortable>(elements: T[]): T[] => {
  if (elements.length === 0) return []

  return elements.map((element, index) => ({
    ...element,
    afterId: index === 0 ? null : elements[index - 1].id,
    beforeId: index === elements.length - 1 ? null : elements[index + 1].id,
  }))
}

export const sort = <T extends Sortable>(elements: T[]): T[] => {
  const elementMap = new Map<string, T>(elements.map((element) => [element.id, element]))
  const visited = new Set<string>()

  const buildArray = (start: T): T[] => {
    const array: T[] = []
    const localVisited = new Set<string>()
    let current: T | undefined = start

    while (current) {
      if (localVisited.has(current.id)) break
      localVisited.add(current.id)
      array.unshift(current)
      current = current.afterId ? elementMap.get(current.afterId) : undefined
    }

    current = start.beforeId ? elementMap.get(start.beforeId) : undefined
    while (current) {
      if (localVisited.has(current.id)) break
      localVisited.add(current.id)
      array.push(current)
      current = current.beforeId ? elementMap.get(current.beforeId) : undefined
    }

    return array
  }

  let longestChain: T[] = []

  for (const element of elements) {
    if (visited.has(element.id)) continue
    const chain = buildArray(element)
    if (chain.length > longestChain.length) {
      longestChain = chain
    }
  }

  for (const item of longestChain) {
    visited.add(item.id)
  }

  const leftovers = elements.filter((element) => !visited.has(element.id))
  longestChain.push(...leftovers)

  return longestChain
}

export const getSpliceIndex = (overIndex: number, targetIndexes: number[], activeIndex: number) => {
  const adjustment = activeIndex < overIndex ? 1 : 0
  const countBefore = targetIndexes.filter((targetIndex) => targetIndex < overIndex).length
  return overIndex - countBefore + adjustment
}
